/* --------------------------------------------------------------------------
   Central limits & reused helpers
   -------------------------------------------------------------------------- */
export const MIN_POLICY_CHARS   = 300;
export const MAX_POLICY_CHARS   = 5000;

export const MAX_ZONE_NAME_CHARS = 60;

export const MAX_METHODS        = 8;      // per zone

export const MAX_ZONES = 12;
export const ETA_RE = /^(\d+)\s*(?:-|–)\s*(\d+)\s*(business\s*days|hours|minutes)?$/i;
export const ETA_UNITS = ["business_days", "hours", "minutes"];